export default __webpack_public_path__ + "static/media/agce.85d77606.gif";